var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNotifications124X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_notifications1_24x24",
    transform: "translate(-5 -3.489)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M12.4,21.5a1.793,1.793,0,0,0,1.8-1.8H10.5A1.88,1.88,0,0,0,12.4,21.5Z",
    transform: "translate(.099 -.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M18.074,15.991v-4.6c0-2.8-1.52-5.2-4.257-5.8V4.9A1.355,1.355,0,0,0,12.5,3.5a1.293,1.293,0,0,0-1.419,1.3v.7a5.673,5.673,0,0,0-4.257,5.8v4.7L5,17.79v.9H20v-.9Zm-9.324.9v-5.5c0-2.3,1.419-4.2,3.75-4.2s3.75,1.9,3.75,4.2v5.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNotifications124X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_notifications1_24x24.b303b5f7327510fff1d70c320f841f64.svg";